module.exports = __webpack_public_path__ + "img/Feature.efb4ac32.png";